import { useState } from 'react';
import cn from 'clsx';
import styles from './Tabs.module.scss';

const Tabs = ({ tabs = [], value, defaultValue = 0, onChange, className }) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue);
  const activeValue = isControlled ? value : internalValue;

  const handleClick = (tabValue) => {
    if (!isControlled) {
      setInternalValue(tabValue);
    }
    onChange?.(tabValue);
  };

  return (
    <div className={cn(styles.tabs, className)}>
      {tabs.map((tab, index) => {
        const tabValue = tab.value ?? index;
        const label = tab.label ?? tab;

        return (
          <button
            key={tabValue}
            type="button"
            className={cn(styles.tab, { [styles.active]: activeValue === tabValue })}
            onClick={() => handleClick(tabValue)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
